import React from 'react'
import { Helmet } from 'react-helmet'

import MainLayout from '../containers/MainLayout'
import CommercialsSystem from '../components/CommercialsSystem'

const AffidavitsPage = () => {
  return (
    <MainLayout fullheight>
      <Helmet>
        <title>Commercials - TAA Music</title>
      </Helmet>
      <div className='container'>
        <CommercialsSystem />
      </div>
    </MainLayout>
  )
}

export default AffidavitsPage
